'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialCss3 = function IoSocialCss3(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 26.5z m-15-24h30l-2.7 31.5-12.3 3.5-12.3-3.5z m22.7 26.2l1.8-19.7h-18.9l0.3 3.8h14.4l-0.3 4h-9.5l0.4 3.9h8.7l-0.4 5-4.2 1.2-4.1-1.2-0.4-3.1h-3.7l0.5 6.1 7.7 2.2z' })
        )
    );
};

exports.default = IoSocialCss3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-css3.js
// module id = 2457
// module chunks = 0